query getPersonInAllocation($aggregateId: String!) {
  person: getPerson(aggregateId: $aggregateId) {
    surname
    aggregateId
    firstName
    preferredName
    fte
  }
}

mutation changePersonSupplyGroup($personId: ID!, $groupId: ID) {
  result: changePersonSupplyGroup(personId: $personId, groupId: $groupId)
}
